import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import "./MemberDashboard.css";

import {
  Bell,
  LogOut
} from "lucide-react";

const MemberDashboard = () => {

  const navigate = useNavigate();

  /* ======================================
          HIDE WEBSITE NAVBAR
  ====================================== */

  useEffect(() => {

    const websiteNavbar =
      document.querySelector(".navbar");

    if (websiteNavbar) {

      websiteNavbar.style.display = "none";

    }

    return () => {

      if (websiteNavbar) {

        websiteNavbar.style.display = "";

      }

    };

  }, []);

  /* ======================================
          USER DETAILS
  ====================================== */

  const memberName =
    localStorage.getItem("name") ||
    "Elite Member";
      /* ======================================
          NAVIGATION
  ====================================== */

  const handleAssessment = () => {

    navigate("/assessments");

  };

  const handleCourse = () => {

    window.open(

      "https://learn.forgeyourpeak.in/web/courses",

      "_blank"

    );

  };

  const handleReports = () => {

    navigate("/report");

  };

  const handleLeaderboard = () => {

    navigate("/leaderboard");

  };

  /* ======================================
          LOGOUT
  ====================================== */

  const logout = () => {

    localStorage.removeItem("email");
    localStorage.removeItem("name");
    localStorage.removeItem("profilePhoto");
    localStorage.removeItem("service");
    localStorage.removeItem("token");

    // If you want to clear everything instead,
    // use: localStorage.clear();

    navigate("/");

  };
    return (

    <div className="member-dashboard">

      {/* ======================================
                  NAVBAR
      ====================================== */}

      <header className="dashboard-navbar">

        <div
          className="dashboard-logo"
          onClick={() => navigate("/member-dashboard")}
        >

          <img
            src="/logo.png"
            alt="Forge Your Peak"
          />

          <span>

            Forge Your Peak

          </span>

        </div>

        <div className="dashboard-right">

          <button className="notification-btn">

            <Bell size={20} />

          </button>

          <button
            className="navbar-logout-btn"
            onClick={logout}
          >

            <LogOut size={18} />

            Logout

          </button>

        </div>

      </header>

      {/* ======================================
                  HERO
      ====================================== */}

      <section className="dashboard-hero">

        <div className="elite-badge">

          ELITE MEMBER

        </div>

        <h1>

          Welcome Back,
          <span> {memberName}</span>

        </h1>

        <p>

          Continue your performance journey.
          Your peak potential is just ahead.

        </p>

      </section>

      {/* ======================================
                  DASHBOARD GRID
      ====================================== */}

      <section className="dashboard-grid">

        {/* ==========================
              START ASSESSMENT
        ========================== */}

        <div className="dashboard-card">

          <div className="card-icon">

            🧠

          </div>

          <h2>

            Start Assessment

          </h2>

          <p>

            Take your latest vision and cognitive assessment
            to track your progress and optimize results.

          </p>

          <button
            className="card-btn"
            onClick={handleAssessment}
          >

            Start Assessment

            <span>

              →

            </span>

          </button>

        </div>

        {/* ==========================
              CONTINUE COURSE
        ========================== */}

        <div className="dashboard-card">

          <div className="card-icon">

            📖

          </div>

          <h2>

            Continue Course

          </h2>

          <p>

            Resume your learning where you left off.
            Continue your Vision Performance journey.

          </p>

          <button
            className="card-btn"
            onClick={handleCourse}
          >

            Continue Course

            <span>

              →

            </span>

          </button>

        </div>
                {/* ==========================
              VIEW REPORTS
        ========================== */}

        <div className="dashboard-card">

          <div className="card-icon">

            📄

          </div>

          <h2>

            View Reports

          </h2>

          <p>

            Analyze your latest assessment reports,
            visual metrics and historical performance.

          </p>

          <button
            className="card-btn"
            onClick={handleReports}
          >

            View Reports

            <span>

              →

            </span>

          </button>

        </div>

        {/* ==========================
              LEADERBOARD
        ========================== */}

        <div className="dashboard-card">

          <div className="card-icon">

            🏆

          </div>

          <h2>

            Leaderboard

          </h2>

          <p>

            Compare your performance with other
            elite athletes in Forge Your Peak.

          </p>

          <button
            className="card-btn"
            onClick={handleLeaderboard}
          >

            Leaderboard

            <span>

              →

            </span>

          </button>

        </div>

      </section>

    </div>

  );

};

export default MemberDashboard;